import React, { Component } from "react";

class UnAuthorized extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Reset Password
            </div>
        );
    }
}

export default UnAuthorized;
